/**
 * Do not edit directly
 * Generated on June 9, 2026
 */

import { CSSProperties } from 'react'

export const Headline1: CSSProperties = {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '32px',
    textTransform: 'none',
}
export const Headline2: CSSProperties = {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    textTransform: 'none',
}
export const Headline3: CSSProperties = {
    fontSize: '16px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    textTransform: 'none',
}
export const Headline4: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'none',
}
export const Headline5: CSSProperties = {
    fontSize: '12px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'uppercase',
}
export const TextM: CSSProperties = {
    fontSize: '16px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    textTransform: 'none',
}
export const TextlinkM: CSSProperties = {
    fontSize: '16px',
    textDecoration: 'underline',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    textTransform: 'none',
}
export const TextS: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'none',
}
export const TextSEmphasis: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'none',
}
export const TextlinkS: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'underline',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'none',
}
export const TextXs: CSSProperties = {
    fontSize: '12px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '14px',
    textTransform: 'none',
}
export const GraphLabel: CSSProperties = {
    fontSize: '10px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '10px',
    textTransform: 'none',
}
export const Link: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'none',
}
export const LinkCaps: CSSProperties = {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    textTransform: 'uppercase',
}
export const ValueL: CSSProperties = {
    fontSize: '40px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '40px',
    textTransform: 'none',
}
export const ValueM: CSSProperties = {
    fontSize: '32px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '32px',
    textTransform: 'none',
}
export const ValueS: CSSProperties = {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    textTransform: 'none',
}
export const Popup = { boxShadow: '0px 0px 25px 0px #00000026' }
export const Flyout = { boxShadow: '0px 5px 15px 0px #0000001a' }
export const SizingCornerNone = '0px'
export const SizingCornerS = '4px'
export const SizingCornerM = '8px'
export const SizingCornerL = '12px'
export const SizingCornerRound = '999px'
export const SizingIconS = '16px'
export const SizingIconM = '24px'
export const SizingIconL = '32px'
export const SizingBorderS = '1px'
export const SizingBorderM = '2px'
export const SizingSpacing100 = '8px'
export const SizingSpacing150 = '12px'
export const SizingSpacing200 = '16px'
export const SizingSpacing300 = '24px'
export const SizingSpacing400 = '32px'
export const SizingSpacing500 = '40px'
export const SizingSpacing600 = '48px'
export const SizingSpacing800 = '64px'
export const SizingSpacing1000 = '80px'
export const SizingSpacing1200 = '96px'
export const SizingSpacingNone = '0px'
export const SizingSpacing025 = '2px'
export const SizingSpacing050 = '4px'
export const SizingSpacing075 = '6px'
export const SizingHeightWidgetSingle = '120px'
export const SizingHeightWidgetDouble = '264px'
export const SizingHeightWidgetTriple = '408px'
export const ColorTextSubtlest = '#b3b3b3ff'
export const ColorTextSubtle = '#808080ff'
export const ColorTextDefault = '#676767ff'
export const ColorTextBold = '#000000ff'
export const ColorTextInverse = '#ffffffff'
export const ColorTextDisabled = '#c4c4c4ff'
export const ColorTextDangerSubtle = '#e56b63ff'
export const ColorTextDangerDefault = '#7c3737ff'
export const ColorTextLinkDefault = '#232f75ff'
export const ColorTextLinkHover = '#128567ff'
export const ColorTextLinkSelected = '#17ad86ff'
export const ColorTextLinkPressed = '#0c5a45ff'
export const ColorTextBoldest = '#08124aff'
export const ColorTextPositiveSubtle = '#17ad86ff'
export const ColorTextPositiveDefault = '#0c5a45ff'
export const ColorTextWarningSubtle = '#e3a84fff'
export const ColorTextWarningDefault = '#584528ff'
export const ColorTextInformativeSubtle = '#74a8e4ff'
export const ColorTextInformativeDefault = '#2b3e54ff'
export const ColorTextAccentRoyal = '#08124aff'
export const ColorTextAccentBlue = '#2b3e54ff'
export const ColorTextAccentGreen = '#0c5a45ff'
export const ColorTextAccentTurquoise = '#275558ff'
export const ColorTextAccentLeaf = '#3e5832ff'
export const ColorTextAccentLime = '#5d621eff'
export const ColorTextAccentOrange = '#584528ff'
export const ColorTextAccentRed = '#7c3737ff'
export const ColorTextAccentGrape = '#5f2133ff'
export const ColorTextAccentPurple = '#3d2a55ff'
export const ColorTextAccentGrey = '#676767ff'
export const ColorIconSubtlest = '#b3b3b3ff'
export const ColorIconSubtle = '#808080ff'
export const ColorIconDefault = '#676767ff'
export const ColorIconInverse = '#ffffffff'
export const ColorIconDisabled = '#c4c4c4ff'
export const ColorIconLinkDefault = '#232f75ff'
export const ColorIconLinkHover = '#128567ff'
export const ColorIconLinkSelected = '#17ad86ff'
export const ColorIconLinkPressed = '#0c5a45ff'
export const ColorIconPositive = '#17ad86ff'
export const ColorIconWarning = '#e3a84fff'
export const ColorIconInformative = '#74a8e4ff'
export const ColorIconDanger = '#e56b63ff'
export const ColorIconBoldest = '#0a1866ff'
export const ColorIconAccentGreen = '#17ad86ff'
export const ColorIconAccentRed = '#e56b63ff'
export const ColorIconAccentOrange = '#e3a84fff'
export const ColorIconAccentBlue = '#74a8e4ff'
export const ColorIconAccentGrey = '#9e9e9eff'
export const ColorIconAccentLeaf = '#80bd61ff'
export const ColorIconAccentLime = '#d7e257ff'
export const ColorIconAccentRoyal = '#0a1866ff'
export const ColorIconAccentTurquoise = '#66c8ceff'
export const ColorIconAccentGrape = '#dc5f84ff'
export const ColorIconAccentPurple = '#9777c0ff'
export const ColorIconDiscovery = '#9777c0ff'
export const ColorGraphNeutralLightest = '#e6e6e6ff'
export const ColorGraphNeutralLight = '#b3b3b3ff'
export const ColorGraphNeutralMedium = '#9e9e9eff'
export const ColorGraphNeutralDark = '#757575ff'
export const ColorGraphNeutralDarker = '#676767ff'
export const ColorGraphNeutralDarkest = '#333333ff'
export const ColorGraphNeutralLighter = '#c4c4c4ff'
export const ColorGraphBinaryPositiveLight = '#8ad5c2ff'
export const ColorGraphBinaryPositiveMedium = '#17ad86ff'
export const ColorGraphBinaryPositiveDark = '#128567ff'
export const ColorGraphBinaryNegativeLight = '#eda29dff'
export const ColorGraphBinaryNegativeMedium = '#e56b63ff'
export const ColorGraphBinaryNegativeDark = '#b7564fff'
export const ColorGraphSequentialOneLight = '#a3a9ccff'
export const ColorGraphSequentialOneMedium = '#0a1866ff'
export const ColorGraphSequentialOneDarkest = '#08124aff'
export const ColorGraphSequentialOneLightest = '#f2f4ffff'
export const ColorGraphSequentialTwoLight = '#bed2e9ff'
export const ColorGraphSequentialTwoMedium = '#74a8e4ff'
export const ColorGraphSequentialTwoDark = '#5b84b2ff'
export const ColorGraphSequentialTwoLightest = '#ebf4ffff'
export const ColorGraphSequentialTwoDarkest = '#2b3e54ff'
export const ColorGraphSequentialThreeLight = '#bee6e9ff'
export const ColorGraphSequentialThreeMedium = '#66c8ceff'
export const ColorGraphSequentialThreeDark = '#5ab0b5ff'
export const ColorGraphSequentialThreeLightest = '#ecf8f9ff'
export const ColorGraphSequentialThreeDarkest = '#275558ff'
export const ColorGraphSequentialFiveLight = '#bae0a8ff'
export const ColorGraphSequentialFiveMedium = '#80bd61ff'
export const ColorGraphSequentialFiveDark = '#6f9c59ff'
export const ColorGraphSequentialFiveLightest = '#f3faf0ff'
export const ColorGraphSequentialFiveDarkest = '#3e5832ff'
export const ColorGraphSequentialSixLight = '#e3e8a3ff'
export const ColorGraphSequentialSixMedium = '#d7e257ff'
export const ColorGraphSequentialSixDark = '#c0c94dff'
export const ColorGraphSequentialSixDarkest = '#5d621eff'
export const ColorGraphSequentialSixLightest = '#f8f9e7ff'
export const ColorGraphSequentialSevenLight = '#eaca9bff'
export const ColorGraphSequentialSevenMedium = '#e3a84fff'
export const ColorGraphSequentialSevenDark = '#bf8835ff'
export const ColorGraphSequentialSevenLightest = '#fff7ebff'
export const ColorGraphSequentialSevenDarkest = '#584528ff'
export const ColorGraphSequentialNineLight = '#e4a2b6ff'
export const ColorGraphSequentialNineMedium = '#dc5f84ff'
export const ColorGraphSequentialNineDark = '#b53e61ff'
export const ColorGraphSequentialNineLightest = '#faeff3ff'
export const ColorGraphSequentialNineDarkest = '#5f2133ff'
export const ColorGraphSequentialTenLight = '#c4b1deff'
export const ColorGraphSequentialTenMedium = '#9777c0ff'
export const ColorGraphSequentialTenDark = '#593e7dff'
export const ColorGraphSequentialTenLightest = '#f4f1f9ff'
export const ColorGraphSequentialTenDarkest = '#3d2a55ff'
export const ColorGraphSequentialEightLight = '#eda29dff'
export const ColorGraphSequentialEightMedium = '#e56b63ff'
export const ColorGraphSequentialEightDark = '#b7564fff'
export const ColorGraphSequentialEightLightest = '#fff1f0ff'
export const ColorGraphSequentialEightDarkest = '#7c3737ff'
export const ColorGraphSequentialFourLight = '#8ad5c2ff'
export const ColorGraphSequentialFourMedium = '#17ad86ff'
export const ColorGraphSequentialFourDark = '#128567ff'
export const ColorGraphSequentialFourLightest = '#f0faf7ff'
export const ColorGraphSequentialFourDarkest = '#0c5a45ff'
export const ColorSurfaceDefault = '#ffffffff'
export const ColorSurfaceHover = '#0000000f'
export const ColorSurfacePressed = '#0000001f'
export const ColorSurfaceSelectedDefault = '#f0faf7ff'
export const ColorSurfaceSelectedHover = '#e8f1eeff'
export const ColorSurfaceSelectedPressed = '#bedad3ff'
export const ColorSurfaceSelectedDisabled = '#e6e6e6ff'
export const ColorSurfaceDisabled = '#f2f2f2ff'
export const ColorSurfaceInformativeDefault = '#ebf4ffff'
export const ColorSurfaceInformativeBoldDefault = '#74a8e4ff'
export const ColorSurfaceInformativeBoldHover = '#5b84b2ff'
export const ColorSurfaceInformativeBoldPressed = '#2b3e54ff'
export const ColorSurfaceInformativeHover = '#e3ebf6ff'
export const ColorSurfaceInformativeInverseDefault = '#e3ebf6ff'
export const ColorSurfaceInformativeInverseHover = '#d5e0ebff'
export const ColorSurfaceInformativeInversePressed = '#bed2e9ff'
export const ColorSurfaceInformativePressed = '#d5e0ebff'
export const ColorSurfaceWarningDefault = '#fff7ebff'
export const ColorSurfaceWarningBoldDefault = '#e3a84fff'
export const ColorSurfaceWarningBoldHover = '#bf8835ff'
export const ColorSurfaceWarningBoldPressed = '#584528ff'
export const ColorSurfaceWarningHover = '#f6eee3ff'
export const ColorSurfaceWarningInverseDefault = '#f6eee3ff'
export const ColorSurfaceWarningInverseHover = '#eae0cfff'
export const ColorSurfaceWarningInversePressed = '#eaca9bff'
export const ColorSurfaceWarningPressed = '#eae0cfff'
export const ColorSurfaceDangerDefault = '#fff1f0ff'
export const ColorSurfaceDangerBoldDefault = '#e56b63ff'
export const ColorSurfaceDangerBoldHover = '#b7564fff'
export const ColorSurfaceDangerBoldPressed = '#7c3737ff'
export const ColorSurfaceDangerHover = '#f6e8e8ff'
export const ColorSurfaceDangerInverseDefault = '#f6e8e8ff'
export const ColorSurfaceDangerInverseHover = '#ebd3d3ff'
export const ColorSurfaceDangerInversePressed = '#eda29dff'
export const ColorSurfaceDangerPressed = '#ebd3d3ff'
export const ColorSurfacePositiveBoldDefault = '#17ad86ff'
export const ColorSurfacePositiveBoldHover = '#128567ff'
export const ColorSurfacePositiveBoldPressed = '#0c5a45ff'
export const ColorSurfacePositiveDefault = '#f0faf7ff'
export const ColorSurfacePositiveHover = '#e8f1eeff'
export const ColorSurfacePositiveInverseDefault = '#e8f1eeff'
export const ColorSurfacePositiveInverseHover = '#bedad3ff'
export const ColorSurfacePositiveInversePressed = '#8ad5c2ff'
export const ColorSurfacePositivePressed = '#bedad3ff'
export const ColorSurfaceAccentRoyalDefault = '#f2f4ffff'
export const ColorSurfaceAccentRoyalBold = '#0a1866ff'
export const ColorSurfaceAccentBlueDefault = '#ebf4ffff'
export const ColorSurfaceAccentBlueBold = '#74a8e4ff'
export const ColorSurfaceAccentTurquoiseDefault = '#ecf8f9ff'
export const ColorSurfaceAccentTurquoiseBold = '#66c8ceff'
export const ColorSurfaceAccentGreenDefault = '#f0faf7ff'
export const ColorSurfaceAccentGreenBold = '#17ad86ff'
export const ColorSurfaceAccentLeafDefault = '#f3faf0ff'
export const ColorSurfaceAccentLeafBold = '#80bd61ff'
export const ColorSurfaceAccentLimeDefault = '#f8f9e7ff'
export const ColorSurfaceAccentLimeBold = '#d7e257ff'
export const ColorSurfaceAccentOrangeDefault = '#fff7ebff'
export const ColorSurfaceAccentOrangeBold = '#e3a84fff'
export const ColorSurfaceAccentRedDefault = '#fff1f0ff'
export const ColorSurfaceAccentRedBold = '#e56b63ff'
export const ColorSurfaceAccentGrapeDefault = '#faeff3ff'
export const ColorSurfaceAccentGrapeBold = '#dc5f84ff'
export const ColorSurfaceAccentPurpleDefault = '#f4f1f9ff'
export const ColorSurfaceAccentPurpleBold = '#9777c0ff'
export const ColorSurfaceAccentGreyDefault = '#f2f2f2ff'
export const ColorSurfaceAccentGreyBold = '#808080ff'
export const ColorSurfaceLoading = '#e6e6e6ff'
export const ColorSurfaceInverseDefault = '#f6f6f6ff'
export const ColorSurfaceInverseHover = '#e6e6e6ff'
export const ColorSurfaceInversePressed = '#c4c4c4ff'
export const ColorSurfaceAnnotatedBoldDefault = '#f2ef5aff'
export const ColorSurfaceAnnotatedBoldHover = '#dbd851ff'
export const ColorSurfaceAnnotatedBoldPressed = '#a9a73fff'
export const ColorSurfaceAnnotatedDefault = '#fdfbe6ff'
export const ColorSurfaceAnnotatedHover = '#f4f2deff'
export const ColorSurfaceAnnotatedInverseDefault = '#f4f2deff'
export const ColorSurfaceAnnotatedInverseHover = '#ededd1ff'
export const ColorSurfaceAnnotatedInversePressed = '#faf9bdff'
export const ColorSurfaceAnnotatedPressed = '#ededd1ff'
export const ColorSurfaceDiscoveryDefault = '#f4f1f9ff'
export const ColorSurfaceDiscoveryHover = '#eeeaf2ff'
export const ColorSurfaceDiscoveryPressed = '#dcd6e3ff'
export const ColorSurfaceDiscoveryInverseDefault = '#eeeaf2ff'
export const ColorSurfaceDiscoveryInverseHover = '#dcd6e3ff'
export const ColorSurfaceDiscoveryInversePressed = '#c4b1deff'
export const ColorSurfaceDiscoveryBoldDefault = '#9777c0ff'
export const ColorSurfaceDiscoveryBoldHover = '#593e7dff'
export const ColorSurfaceDiscoveryBoldPressed = '#3d2a55ff'
export const ColorBackgroundLight = '#ffffffff'
export const ColorBackgroundDark = '#f2f2f2ff'
export const ColorBackgroundOverlay = '#0000003d'
export const ColorBorderDefault = '#e6e6e6ff'
export const ColorBorderSelectedDefault = '#17ad86ff'
export const ColorBorderSelectedDisabled = '#c4c4c4ff'
export const ColorBorderPositive = '#17ad86ff'
export const ColorBorderDanger = '#e56b63ff'
export const ColorBorderWarning = '#e3a84fff'
export const ColorBorderInformative = '#74a8e4ff'
export const ColorBorderFocused = '#0a1866ff'
export const ColorBorderDisabled = '#f2f2f2ff'
export const ColorBorderInverse = '#ffffffff'
export const ColorBorderAnnotatedDefault = '#f2ef5aff'
export const ColorBorderAnnotatedSelected = '#dbd851ff'
export const ColorBorderDiscovery = '#9777c0ff'
export const ColorBorderAccentRoyal = '#0a1866ff'
export const ColorBorderAccentBlue = '#74a8e4ff'
export const ColorBorderAccentTurquoise = '#66c8ceff'
export const ColorBorderAccentGreen = '#17ad86ff'
export const ColorBorderAccentLeaf = '#80bd61ff'
export const ColorBorderAccentLime = '#d7e257ff'
export const ColorBorderAccentOrange = '#e3a84fff'
export const ColorBorderAccentRed = '#e56b63ff'
export const ColorBorderAccentGrape = '#dc5f84ff'
export const ColorBorderAccentPurple = '#9777c0ff'
export const ColorBorderAccentGrey = '#808080ff'
export const FontWeightRegular = 'Regular'
export const FontWeightMedium = 'Medium'
export const FontWeightSemibold = 'SemiBold'
export const FontSizeMd = '16px'
export const FontSizeSm = '14px'
export const FontSizeXs = '12px'
export const FontSize2xs = '10px'
export const FontSize3xl = '40px'
export const FontSize2xl = '32px'
export const FontSizeXl = '24px'
export const FontSizeLg = '18px'
export const FontLineheightMd = '24px'
export const FontLineheightSm = '18px'
export const FontLineheightXs = '14px'
export const FontLineheight2xs = '10px'
export const FontLineheightLg = '32px'
export const FontLineheightXl = '40px'
export const FontLineheight2xl = '40px'
export const DocumentFormatPdf = 'PDF'
export const DocumentFormatCsv = 'CSV'
export const DocumentFormatJpeg = 'JPEG'
export const DocumentFormatPng = 'PNG'
export const DocumentFormatXml = 'XML'
export const UnitsMonetaryEuro = '€'
export const UnitsMonetaryPerTimeEuroPerYear = '€/Jahr'
export const UnitsMonetaryPerTimeEuroPerMonth = '€/Monat'
export const UnitsMonetaryPerTimeEuroPerAnnum = '€ p.a.'
export const UnitsMonetaryPerTimeEuroPerMensem = '€ p.M.'
export const UnitsMonetaryPerAreaEuroPerSquareMeter = '€/m²'
export const UnitsMonetaryPerAreaEuroPerSquareMeterPerMonth = '€/m² p.M.'
export const UnitsMonetaryPerPieceEuroPerUnit = '€/EH'
export const UnitsMonetaryPerPieceEuroPerUnitPerMensem = '€/EH p.M.'
export const UnitsMonetaryPerPieceEuroPerParkingLot = '€/Stpl.'
export const UnitsMonetaryPerPieceEuroPerParkingLotPerMensem = '€/Stpl. p.M.'
export const UnitsMonetaryPerPieceEuroPerUnitPerAnnum = '€/EH p.a.'
export const UnitsMonetaryPerPieceEuroPerParkingLotPerAnnum = '€/Stpl. p.a.'
export const UnitsTimeYears = 'Jahre'
export const UnitsTimeMonths = 'Monate'
export const UnitsTimeDays = 'Tage'
export const UnitsTimeHours = 'Stunden'
export const UnitsTimeMinutes = 'Minuten'
export const UnitsPercentagesPercentOfGrossIncome = '% RoE'
export const UnitsPercentagesPercentOfManagementCosts = '% BWK'
export const UnitsPercentagesPercent = '%'
export const UnitsPercentagesPercentagePoints = 'BP'
export const UnitsDimensionsSquareMeters = 'm²'
export const UnitsDimensionsMeters = 'm'
export const UnitsDimensionsKilometers = 'km'
export const UnitsDimensionsSquareKilometers = 'km²'
export const UnitsDimensionsCubicMeters = 'm³'
export const UnitsDimensionsCubicKilometers = 'km³'
export const UnitsDimensionsCentimeters = 'cm'
export const UnitsDimensionsMillimeters = 'mm'
export const UnitsPiecesEntity = 'EH'
export const UnitsPiecesParkingLots = 'Stpl.'
export const StatesDash = '-'
